// Node
const $ = require('jquery');

import i18next from 'i18next';

class GuestsWidget {
  constructor (formId, options = {}) {
    this.build = this.build.bind(this);
    this.build(formId, options);
  }

  build (formId, options) {
    this.$form = $(`form#${formId}`);

    this.$childrenAges = this.$form.find(`#${options.childrenAges}`);
    this.$childrenCount = this.$form.find(`#${options.childrenCount}`);
    this.$countGuests = this.$form.find(`#${options.countGuests}`);
    this.$totalAdultsCount = this.$form.find(`#${options.totalAdultsCount}`);
    this.$totalChildrenCount = this.$form.find(`#${options.totalChildrenCount}`);
    this.$guestChildNumber = this.$form.find(`#${options.guestChildNumber}`);
    this.$withPetCheckbox = this.$form.find(`#${options.withPetCheckbox}`);
  }

  init () {
    this.syncInflection();
    this._initTotalCount();
    this._initTotalCountBtns();
    this._initInputsAgesOfChildren();
    this._initValues();
    this._initMobilePopupAges();
    this._initMobilePopdownAges();
  }

  reset () {
    this.$childrenCount.val(0).trigger('change');
    this.$childrenCount.siblings('.guest-line__count-numb').text('0');
    this.$childrenAges.data('ages', []);

    this.$countGuests.val(2).trigger('change');
    this.$countGuests.siblings('.guest-line__count-numb').text('2');

    this.$totalAdultsCount.val(2);
    this.$guestChildNumber.val(0);
  }

  /**
   * @param {number} newCountGuests
   * @param {Array<number>} childrenAges
   * @param {boolean} withPet
   */
  updateOutside(newCountGuests, childrenAges = [], withPet = false) {
    // Синхронизируем состояние элементов виджета, связанных с питомцами
    this.$withPetCheckbox?.prop('checked', withPet);

    // Синхронизируем состояние элементов виджета, связанных с количеством взрослых
    this.$countGuests.val(newCountGuests);
    this.$countGuests.parent().find('.guest-line__count-numb').text(newCountGuests);
    this._determineCountBtnsAvailability(this.$countGuests);

    // Синхронизируем состояние элементов виджета, связанных с детьми
    this.$childrenCount.val(childrenAges.length).trigger('change');
    this.$childrenCount.parent().find('.guest-line__count-numb').text(childrenAges.length);
    this._determineCountBtnsAvailability(this.$childrenCount);
    this.$childrenAges.html('');
    this.$childrenAges.data('ages', childrenAges);
    this._initValues();
  }

  // private

  // Синхронизирует склонение родителей и детей
  syncInflection() {
    var adult = parseInt(this.$totalAdultsCount.val());
    var child = parseInt(this.$totalChildrenCount.val());
    let with_pet = this.$withPetCheckbox?.prop('checked');
    this._setGuestsCount(adult, child);
    if (child == 0) {
      let adult_string = i18next.t('adult', { count: adult });
      if (with_pet) adult_string += ',';
      this.$totalAdultsCount.parent().children('.adult').val(adult_string);
      this.$totalChildrenCount.parent().children('.child_pair').hide();
    } else {
      this.$totalAdultsCount.parent().children('.adult').val( i18next.t('adult', { count: adult }) + ',');
      let child_string = i18next.t('child', { count: child });
      if (with_pet) child_string += ',';
      this.$totalChildrenCount.parent().children('.child').val(child_string);
      this.$totalChildrenCount.parent().children('.child_pair').show();
    }
    if (with_pet) {
      this.$totalChildrenCount.parent().children('.pet').removeClass('hidden');
    } else {
      this.$totalChildrenCount.parent().children('.pet').addClass('hidden');
    }
  }

  // Добавляет или удаляет инпуты для возраста детей при изменении их количества
  _initTotalCount() {
    const handler = function () {
      let countGuests = parseInt(this.$countGuests.val());
      let childrenCount = parseInt(this.$childrenCount.val());
      this.$totalAdultsCount.val(countGuests);
      this.$totalChildrenCount.val(childrenCount);
      this.syncInflection();
    };

    this.$childrenCount.on('change', handler.bind(this));
    this.$countGuests.on('change', handler.bind(this))
    this.$withPetCheckbox?.on('change', handler.bind(this))
  }

  _initTotalCountBtns() {
    this.$form.find('.more, .less').on('click', function () {
      if ($(this).hasClass('guest-line__count-btn_disable')) {
        return;
      }
      let guests_field = $(`#${$(this).attr('target_input') || $(this).data('target_input')}`);
      let maxCount = parseInt(guests_field.attr('max'));
      let minCount = parseInt(guests_field.attr('min')) || 0;
      let oldVal = parseInt(guests_field.val());
      let newVal = oldVal;

      if ($(this).hasClass('more') && oldVal < maxCount) {
        newVal = oldVal + 1;
      } else if ($(this).hasClass('less') && oldVal > minCount) {
        newVal = oldVal - 1;
      }

      guests_field.val(newVal);
      guests_field.trigger('change');
      $(this).parent().find('.guest-line__count-numb').text(newVal);

      if (newVal === minCount) {
        $(this).parent().children('.less').addClass('guest-line__count-btn_disable');
      } else if (newVal === maxCount) {
        $(this).parent().children('.more').addClass('guest-line__count-btn_disable');
      } else {
        $(this).parent().children('.less').removeClass('guest-line__count-btn_disable');
        $(this).parent().children('.more').removeClass('guest-line__count-btn_disable');
      }
    });
  }

  /**
   * @param $field `this.$countGuests` OR `this.$childrenCount`
   * @private
   */
  _determineCountBtnsAvailability($field) {
    const currentValue = parseInt($field.val());

    const minCount = parseInt($field.attr('min')) || 0;
    const $btnLess = $field.parent().children('.less');
    if (currentValue <= minCount) {
      $btnLess.addClass('guest-line__count-btn_disable');
    } else {
      $btnLess.removeClass('guest-line__count-btn_disable');
    }

    const maxCount = parseInt($field.attr('max'));
    const $btnMore = $field.parent().children('.more');
    if (currentValue >= maxCount) {
      $btnMore.addClass('guest-line__count-btn_disable');
    } else {
      $btnMore.removeClass('guest-line__count-btn_disable');
    }
  }

  // Добавляет или удаляет инпуты для возраста детей при изменении их количества
  _initInputsAgesOfChildren() {
    let widget = this;

    this.$childrenCount.eq(0).on('change', function () {
      let currentNumOfInputs = widget.$childrenAges.eq(0).find('input').length;

      if (parseInt($(this).val()) >= 0) {
        let i;
        let amount = parseInt($(this).val());
        if (amount > parseInt($(this).attr('max'))) {
          amount = parseInt($(this).attr('max'));
        }

        // Добавить инпуты
        if (currentNumOfInputs < amount) {
          for (i = amount - currentNumOfInputs; i > 0; i--) {
            widget.$childrenAges.each (function () {
              $(this).append(widget._childBlock(undefined, amount, this));
            })
          }
        }
        // Удалить инпуты
        else {
          for (i = currentNumOfInputs - amount; i > 0; i--) {
            widget.$childrenAges.find('.guest-child__input-item:last').remove();
          }
        }
        // Скрыть или открыть блок с инпутами
        $('.guest-child').css('display', (amount === 0) ? 'none' : 'block');
        widget._initMobilePopupAges();
      } else {
        $(this).val(0).trigger('change');
      }
    });
  }

  _initMobilePopupAges() {}

  _initMobilePopdownAges() {}

  _setGuestsCount(adult, child) {
    if (adult) {
      let guests = adult;
      if (child) guests += child;
      $('.search-params__guests').text(i18next.t('guest', { count: guests }));
    }
  }

  // Инициализирует инпуты возрастов детей
  _initValues() {
    let ages = this.$childrenAges.data('ages');
    let widget = this;
    if (ages && (ages.length > 0) && (this.$childrenAges.children('input').length === 0)) {
      this.__range__(0, ages.length, false).map((i) =>
        this.$childrenAges.each(function () {
          $(this).append(widget._childBlock(ages[i], i + 1, this));
        })
      )
    }
  }

  __range__(left, right, inclusive) {
    let range = [];
    let ascending = left < right;
    let end = !inclusive ? right : ascending ? right + 1 : right - 1;

    for (let i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
      range.push(i);
    }

    return range;
  }

  _childBlock(age = parseInt(this.$childrenAges.attr('default_age')) ||
      parseInt(this.$childrenAges.data('default_age')), count, childrenAges) {
    return `<input id="children_age_input"
                   name="children_ages[]"
                   class="guest-child__input-item"
                   type="number"
                   value="${age}"
                   min="1"
                   max="17"
                   onkeydown="return false"
            >`;
  }
}

export default GuestsWidget;
